export default __webpack_public_path__ + "static/media/conference-hall-1.44c5aebc.jpg";